import { render, staticRenderFns } from "./CommonItem.vue?vue&type=template&id=0bef6cbc&scoped=true&"
import script from "./CommonItem.vue?vue&type=script&lang=js&"
export * from "./CommonItem.vue?vue&type=script&lang=js&"
import style0 from "./CommonItem.vue?vue&type=style&index=0&id=0bef6cbc&prod&lang=scss&scoped=true&"
import style1 from "./CommonItem.vue?vue&type=style&index=1&id=0bef6cbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef6cbc",
  null
  
)

export default component.exports